export default "__VITE_ASSET__D9QHvi$r__"